import { Action } from '@ngrx/store';
import { ActivityPreview } from '../../interfaces/module.interface';

export enum ActivityActions {
  LoadActivity = '[Modules] Load Activity',
}

export class LoadActivity implements Action {
  public readonly type = ActivityActions.LoadActivity;
  constructor(public payload: ActivityPreview) {}
}

export type ActivityActionsUnion = LoadActivity;
